export var LAST_INSPECTION_TIME = 20;
export var FIRST_INSPECTION_TIME = 8;
export var TIME_INTERVAL = 30;